/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('SmallBusinessOpenRegistration', {
  Header: 'Create your Viewpost account.',
  Subheader: 'Complete the form below to create and secure your account.'
});
